import axios from "axios";
import Config from "@/Config.js";

const BASE = Config.host + "Image";

/**
 * Imagenes de una entidad, por trozos.
 *
 * Los endpoints que ya existian (ImagesCompany, sites/images) devuelven TODAS
 * las imagenes de golpe, asi que enseñar una miniatura de una empresa con cinco
 * fotos obligaba a descargar las cinco en base64. Esto deja pedirlas en dos
 * tandas: la principal primero, el resto despues.
 *
 * No exige sesion: son las mismas imagenes que ya se ven en las paginas
 * publicas de empresas y lugares.
 */
export default {
  /**
   * @param {string} tipo   "empresa", "lugar" o "producto"
   * @param {number} id     id de la entidad
   * @param {number} desde  cuantas saltar
   * @param {number} limite cuantas traer como mucho; null = las que queden
   */
  deEntidad(tipo, id, desde = 0, limite = null) {
    const params = { desde };

    if (limite !== null) {
      params.limite = limite;
    }
    return axios.get(`${BASE}/entity/${tipo}/${id}`, { params }).then((r) => r.data);
  },

  /** La primera, que es la que sale de miniatura. */
  principal(tipo, id) {
    return this.deEntidad(tipo, id, 0, 1).then((r) => (r.length > 0 ? r[0].pathBase64 : null));
  },

  /** Las demas, para llenar la galeria una vez esta la principal. */
  resto(tipo, id, limite = null) {
    return this.deEntidad(tipo, id, 1, limite).then((r) => r.map((i) => i.pathBase64));
  },
};
